export default "/images/codan.png?e00c24ecd63f278c3cc54cd613af3abd";